import { reactionVideos } from "@/mocks/index";

export default function ReactionSection() {
  return (
    <section id="video" className="scroll-mt-20 bg-stone-900/60 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="mb-3 flex items-center gap-2">
              <span className="text-xs font-semibold uppercase tracking-widest text-amber-400">TRENDING CLIPS</span>
            </div>
            <h2 className="text-2xl font-black text-white md:text-4xl">反应视频 · 全网都在看</h2>
          </div>
          <p className="max-w-md text-sm text-stone-500">
            有人看懂细节、有人笑到捶桌、有人带着全家一起看。反应视频就是一面镜子，照出这段热点的后劲。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3">
          {reactionVideos.map((v, i) => (
            <a
              key={v.id}
              href="#video"
              className="group overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03] transition-colors hover:border-amber-400/40"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={v.image}
                  alt={`${v.channel} 的反应视频《${v.title}》`}
                  title={`${v.title} - ${v.channel}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full bg-stone-950/60 text-xl text-white backdrop-blur-sm transition-all group-hover:scale-110 group-hover:bg-orange-500 group-hover:text-stone-950">
                    <i className="ri-play-fill ml-1" />
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-stone-950/90 to-transparent px-3 py-2">
                  <span className="whitespace-nowrap rounded-md bg-stone-950/70 px-2 py-0.5 text-[11px] text-amber-300">
                    {v.tag}
                  </span>
                  <span className="rounded-md bg-stone-950/70 px-2 py-0.5 font-display text-[11px] text-stone-300">
                    {v.duration}
                  </span>
                </div>
                {i === 0 && (
                  <span className="absolute left-3 top-3 rounded-full bg-orange-500 px-2.5 py-1 text-[11px] font-bold text-stone-950">
                    本周爆款
                  </span>
                )}
              </div>
              <div className="p-5">
                <h3 className="line-clamp-2 text-base font-bold text-white">{v.title}</h3>
                <div className="mt-3 flex items-center justify-between text-sm text-stone-400">
                  <span className="flex items-center gap-2">
                    <i className="ri-tv-2-line text-amber-400" />
                    {v.channel}
                  </span>
                  <span>
                    <i className="ri-eye-line mr-1" />
                    {v.views}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}